export default defineNuxtPlugin(() => {
  const watchFeatureBlock = useWatchFeatureBlock();
  const route = useRoute();
  const router = useRouter();

  watchFeatureBlock.startWatching();

  const checkAndRedirect = () => {
    const currentPath = route.path;

    if (currentPath === "/maintainance") return;
    if (currentPath.startsWith("/v2-owner-report-mobile")) return;

    if (watchFeatureBlock.isPathBlocked(currentPath)) {
      router.replace("/maintainance");
    }
  };

  watch(() => route.path, checkAndRedirect, { immediate: true });
  watch(watchFeatureBlock.featureBlockData, checkAndRedirect, { deep: true });
});
